import React from "react"
import PropTypes from "prop-types"

import "./Characteristics.less"

/* eslint-disable comma-spacing */
const characteristics = {
  estacionamiento   : { key: "estacionamiento"   , text: "停车场"   , img: "/static/img/nh/icon_parking.svg"           , } ,
  aireAcondicionado : { key: "aireAcondicionado" , text: "空调"     , img: "/static/img/nh/icon_aireacondicionado.svg" , } ,
  kids              : { key: "kids"              , text: "幼儿扥管" , img: "/static/img/nh/icon_osito.svg"             , } ,
  accesibilibity    : { key: "accesibilibity"    , text: "无障碍"   , img: "/static/img/nh/icon_accesibilidad.svg"     , } ,
  meeting           : { key: "meeting"           , text: "集会"     , img: "/static/img/nh/icon_fiestas.svg"           , } ,
  albornoz          : { key: "albornoz"          , text: "浴袍"     , img: "/static/img/nh/icon_albornoz.svg"     , } ,
  cafetera          : { key: "cafetera"          , text: "咖啡机"   , img: "/static/img/nh/icon_cafetera.svg"     , } ,
  cama              : { key: "cama"              , text: "超大床"   , img: "/static/img/nh/icon_cama.svg"         , } ,
  ducha             : { key: "ducha"             , text: "淋浴"     , img: "/static/img/nh/icon_ducha.svg"        , } ,
  parking           : { key: "parking"           , text: "停车场"   , img: "/static/img/nh/icon_parking.svg"      , } ,
  tetera            : { key: "tetera"            , text: "水壶"     , img: "/static/img/nh/icon_tetera.svg"       , } ,
  tv                : { key: "tv"                , text: "平板电视" , img: "/static/img/nh/icon_TV.svg"           , } ,
}
/* eslint-enable comma-spacing */

const Characteristics = ({ list }) => (
  <div className="hotel-characteristics">
    {
      list.map(key => (characteristics[key]))
        .map(({ key, text, img }) => (
          <div key={key}>
            <img src={img} />
            <p>{text}</p>
          </div>
        ))
    }
  </div>
)

Characteristics.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default Characteristics



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/components/Characteristics.jsx